@for (option of options$ | async; track $index) {
  <app-tab-option
    [attr.data-test-id]="option.id"
    [selected]="option.isChecked"
    [count]="option.count"
    (click)="selectOption(option)"
  >
    {{ selectDispayValue(option) | translate }}
  </app-tab-option>
}
